import styled, { css } from 'styled-components';

import { VALID_DIMENSION_DATA } from '../Utils/Styles/calcDimensionStyles';
import { cssDeclaration } from '../Utils/Styles/cssDeclaration';

export const DropdownContainer = styled.ul<{ width?: VALID_DIMENSION_DATA }>`
  position: absolute;

  width: 100%;
  overflow-y: scroll;

  ${({ theme: { themeTwo }, width }) => {
    const { form: { autoComplete: { list }}} = themeTwo;
    // update theming to use "card" theme

    return css`
      z-index: ${themeTwo.global.zIndex.high};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', list.backgroundColor)};
      /* box-shadow */ ${cssDeclaration(themeTwo, 'box-shadow', list.shadow)};
      /* height */ ${cssDeclaration(themeTwo, 'height', { max: list.height.max })};
      /* width */ ${ width && cssDeclaration(themeTwo, 'width', width)};
    `;
  }}
`;

export interface IListboxOption {
  isActive?: boolean;
}

const CommonListboxOptionStyles = css`
  ${({ theme: { themeTwo }}) => {
    const { form: { autoComplete: { listItem }}} = themeTwo;

    return css`
      line-height: ${listItem.font.lineHeight};

      /* color */ ${cssDeclaration(themeTwo, 'color', listItem.font.color)};
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', listItem.font.size)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', listItem.padding)};

      &:first-of-type {
        /* margin */ ${cssDeclaration(themeTwo, 'margin', { top: listItem.margin.top })};
      }

      &:last-of-type {
        /* margin */ ${cssDeclaration(themeTwo, 'margin', { bottom: listItem.margin.bottom })};
      }
    `;
  }}
`;

export const ListboxOption = styled.li<IListboxOption>`
  ${CommonListboxOptionStyles}
  cursor: pointer;

  ${({ theme: { themeTwo }, isActive }) => {
    const { form: { autoComplete: { listItem }}} = themeTwo;

    const activeStyles = css`
      /* color */ ${cssDeclaration(themeTwo, 'color', listItem.active.font.color)}
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', listItem.active.backgroundColor)}
    `;

    return css`
      ${isActive && activeStyles};
    `;
  }}
`;

export const ListboxOptionNoResults = styled.li`
  ${CommonListboxOptionStyles}
`;

export const ListboxOptionHeader = styled.li`
  ${CommonListboxOptionStyles}

  ${({ theme: { themeTwo }}) => {
    const { form: { autoComplete: { listItemHeader }}} = themeTwo;

    return css`
      font-weight: ${listItemHeader.font.weight};
      line-height: ${listItemHeader.font.lineHeight};
      /* color */ ${cssDeclaration(themeTwo, 'color',  listItemHeader.font.color)}
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', listItemHeader.font.size)};
    `;
  }}
`;
